import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const CardPost = ({
	name,
	image,
	url,
	date = null,
	tag = null,
	tagUrl = null,
	tagClass = null,
	tagHighlight = null,
	tagHighlightSmall = null,
	description = null,
	showMore = false,
	horizontal = false,
	solutions = false,
	imgClassName = null,
	blank = false,
	customClass = null,
	lang = 'en',
	animation = {},
	size = null,
	showMore2 = false,
	big = false,
	showLinkedIn = false,
}) => {
	let className = 'card card--post';

	if (size === 'lg') {
		className += ' card--post--big';
	}

	if (size) {
		className += ` card--post--horizontal--${size}`;
	}

	if (horizontal) {
		className += ' card--post--horizontal';
	}

	if (solutions) {
		className = 'card';
	}

    const showMoreButton = {
        "en": "Read more",
        "es": "Leer más"
    }
    

	if (customClass) {
		className += ` ${customClass}`;
	}


	const showMoreButton2 = {
		en: 'Read more',
		es: 'Más información',
	};

	const showLinkedInButton = {
		en: `${name} on LinkedIn`,
		es: `${name} en LinkedIn`,
	}

	let title = <Link to={url}>{name}</Link>;

	if (blank) {
		title = (
			<a href={url} target="_blank" rel="noreferrer">
				{name}
			</a>
		);
	}

	const content = <>
			<div className="card__header">
				{tagHighlight && <div className="tag tag--highlight tag--highlight--md">{tagHighlight}</div>}
				{image && image.localFile ? (
					<GatsbyImage
						alt={image.alternativeText}
						image={getImage(image.localFile)}
						className={imgClassName}
						loading={"lazy"}
					/>
				) : null}
			</div>
			<div className="card__body">
				<div className="card__body__details">
					{date && <div className="details__date">{date}</div>}
					{tag && !tagUrl && <div className={`tag ${tagClass}`}>{tag}</div>}
					{tag && tagUrl && (
						<Link to={tagUrl} className="tag">
							{tag}
						</Link>
					)}
					{tagHighlightSmall && (
						<div className="tag tag--highlight tag--highlight--xs">{tagHighlightSmall}</div>
					)}
				</div>

				<div className="card__body__info">
					{size === 'lg' ? <h4>{title}</h4> : <h6>{title}</h6>}
					{description && (
						<div className="card__body__description">
							<ReactMarkdown children={description} rehypePlugins={[rehypeRaw]} />
						</div>
					)}
				</div>


				{!showMore2 && showMore && (
					<span className="card__body__see-more">
						{showMoreButton[lang]} <i className="icon-arrow-right" />
					</span>
				)}

				{showMore2 && (
					<span className="card__body__see-more">
						{showMoreButton2[lang]} <i className="icon-arrow-right" />
					</span>
				)}

				{showLinkedIn && (
					<span className="card__body__see-more">
						{showLinkedInButton[lang]} <i className="icon-arrow-right" />
					</span>
				)}
			</div>
		</>

	return <div className={className} {...animation}>{content}</div>
};

export default CardPost;
